import { type FC, useMemo } from 'react';

import { Select, type SelectProps } from '@/components/common/select/Select';
import { useFormatOperationType } from '@/hooks/use-format-operation-type';

import { SalesChartOperationType } from '../../../../../generated/graphql';

type OperationTypeSelectProps = Omit<SelectProps<SalesChartOperationType>, 'options'> & {
  withAll?: boolean;
};

export const OperationTypeSelect: FC<OperationTypeSelectProps> = (props) => {
  const { withAll, ...selectProps } = props;

  const formatOperationType = useFormatOperationType();

  const options = useMemo(
    () =>
      Object.values(SalesChartOperationType)
        .filter((operationType) => operationType !== SalesChartOperationType.All || withAll)
        .map((type) => ({ node: formatOperationType(type), value: type })),
    [formatOperationType, withAll]
  );

  return <Select options={options} {...selectProps} />;
};
